<!--公司法人信息-->
<template>
  <div class="module">
    <h5 class="module-title">公司法定代表人信息</h5>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="法定代表人名称："
            prop="legalPerson"
            label-width="126px"
          >
            <el-input v-model="ruleForm.legalPerson"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="手机号码："
            prop="legalPersonMobile"
            label-width="96px"
          >
            <el-input v-model="ruleForm.legalPersonMobile"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="证件信息："
            :prop="`settleAccountAttachTempList[${getIndexByFileType(
              'LRC'
            )}].certificateNo`"
            :rules="rules.certificateNo"
            label-width="126px"
            class="document-information"
          >
            <el-select
              v-model="
                ruleForm.settleAccountAttachTempList[getIndexByFileType('LRC')]
                  .certificateType
              "
              placeholder="请选择"
            >
              <el-option
                v-for="item in certificateTypeList"
                :key="item.itemCode"
                :label="item.itemDisp"
                :value="item.itemCode"
              ></el-option>
            </el-select>
            <el-input
              v-model="
                ruleForm.settleAccountAttachTempList[getIndexByFileType('LRC')]
                  .certificateNo
              "
              placeholder="请输入证件号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="证件有效期："
            :prop="`settleAccountAttachTempList[${getIndexByFileType(
              'LRC'
            )}].certificateTimeRange`"
            label-width="96px"
            class="period-of-validity"
          >
            <el-date-picker
              v-model="
                ruleForm.settleAccountAttachTempList[getIndexByFileType('LRC')]
                  .certificateTimeRange
              "
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :disabled="legalPersonDateDisabled"
            >
            </el-date-picker>
            <el-checkbox
              v-model="
                ruleForm.settleAccountAttachTempList[getIndexByFileType('LRC')]
                  .certificateLongValid
              "
              @change="radioChange('LRC')"
              >长期有效
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="证件复印件："
            prop="legalPersonCertificate"
            :rules="rules.attachPath"
            label-width="126px"
          >
            <div class="flex">
              <eui-upload
                ref="euiUpload1"
                key-name="applicantCertificatePath"
                :file-list="fileList.LRC"
                :action="uploadPayCenterFile"
                :private-upload="privateUpload"
                :headers="headers"
                :show-file-list="true"
                accept=".jpg,.png"
                single
                text="上传附件"
                @handleSuccess="() => uploadSuccess('LRC', fileList.LRC)"
              >
              </eui-upload>
              <eui-btn type="secondary" @click="previewUploadFile(fileList.LRC)"
                >预览
              </eui-btn>
              <span
                >请上传身份证证件两面清晰的扫描或复印件，限≤2mb，jpg、png格式。</span
              >
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <viewer-image
      ref="viewer"
      :preview-src-list="[dialogPicUrl]"
    ></viewer-image>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import { paymentAccountOpeningMixins, commonMethodsMixins } from '../constant';
import ViewerImage from '../components/viewerImage';

export default {
  name: 'LegalPersonInfo',
  components: { ViewerImage },
  mixins: [paymentAccountOpeningMixins, commonMethodsMixins],
  data() {
    return {
      ruleForm: {
        legalPerson: '',
        legalPersonMobile: '',
        settleAccountAttachTempList: [
          {
            attachName: '',
            attachPath: '',
            attachType: 'LRC',
            certificateBeginTime: '',
            certificateEndTime: '',
            certificateTimeRange: [],
            certificateLongValid: '',
            certificateNo: '',
            certificateType: 0,
          },
        ],
      },
      fileList: {
        LRC: [],
      },
      legalPersonDateDisabled: false,
    };
  },
  watch: {},
  created() {},
  methods: {
    async initData(sourceData) {
      if (!sourceData?.settleAccountAttachTempList) {
        return;
      }
      this.ruleForm.legalPerson = sourceData?.legalPerson;
      this.ruleForm.legalPersonMobile = sourceData?.legalPersonMobile;
      this.ruleForm.settleAccountAttachTempList.forEach((attachItem, index) => {
        const tempObj = sourceData.settleAccountAttachTempList.find(
          (tempItem) => tempItem.attachType === attachItem.attachType
        );
        if (tempObj) {
          Object.keys(attachItem).forEach((key) => {
            attachItem[key] = tempObj[key] ?? attachItem[key];
          });
          // 附件回显
          if (attachItem?.attachName && attachItem?.attachPath) {
            this.fileList[attachItem.attachType].push({
              name: attachItem.attachName,
              url: attachItem.attachPath,
            });
          }
          attachItem.certificateLongValid = !!attachItem.certificateLongValid;
          attachItem.certificateTimeRange =
            attachItem.certificateBeginTime && attachItem.certificateEndTime
              ? [attachItem.certificateBeginTime, attachItem.certificateEndTime]
              : [];
          this.$set(
            this.ruleForm.settleAccountAttachTempList,
            index,
            attachItem
          );
        }
      });
      console.log(this.ruleForm, 'legalPerson init');
      this.radioChange('LRC');
    },
    // 法人和申请人附件上传
    uploadSuccess(certificateType, attachObj) {
      this.reUploadFlag = true;
      const tempObj = this.ruleForm.settleAccountAttachTempList.find(
        (attach) => attach.attachType === certificateType
      );
      if (tempObj) {
        this.$set(tempObj, 'attachName', attachObj[0]?.response?.data.fileName);
        this.$set(tempObj, 'attachPath', attachObj[0]?.response?.data.url);
        if (certificateType === 'AA' || certificateType === 'AC') {
          Api.addEpaySettleAccountApplicantAttach({
            attachName: attachObj[0]?.response?.data.fileName,
            attachPath: attachObj[0]?.response?.data.url,
            attachType: certificateType,
          });
        }
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/paymentAccountOpening.scss';
</style>
